import React from "react";

const Hero = () => {
  return (
	  <>
    <section className="flex items-center justify-center mx-auto container relative pt-10 md:pt-28 pb-28">
      <div >
        <div>
        <div className="flex items-center justify-center mt-10">
		<div className="w-fit flex items-center rounded-full bg-green-50 px-10 py-2 mb-10 text-green-700"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" className="mr-2" fill="none">
    <path d="M2 3C3.86377 3 4.79565 3 5.53073 3.30448C6.51085 3.71046 7.28954 4.48915 7.69552 5.46927C8 6.20435 8 7.13623 8 9C6.13623 9 5.20435 9 4.46927 8.69552C3.48915 8.28954 2.71046 7.51085 2.30448 6.53073C2 5.79565 2 4.86377 2 3Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
    <path d="M12 5C10.7575 5 10.1362 5 9.64618 5.20299C8.99277 5.47364 8.47364 5.99277 8.20299 6.64618C8 7.13623 8 7.75749 8 9C9.24251 9 9.86377 9 10.3538 8.79701C11.0072 8.52636 11.5264 8.00723 11.797 7.35382C12 6.86377 12 6.24251 12 5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
    <path d="M8 9V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    <path d="M12 14L2 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    <path d="M12 17L2 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    <path d="M12 20L2 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    <path d="M16 18.5034C16 17.2482 17.0532 16.0077 17.7924 15.2917C18.1939 14.9028 18.8061 14.9028 19.2076 15.2917C19.9468 16.0077 21 17.2482 21 18.5034C21 19.7341 20.0533 21 18.5 21C16.9467 21 16 19.7341 16 18.5034Z" stroke="currentColor" stroke-width="1.5" />
</svg> Grow Your Rank, Green the Earth</div>
		</div>
          <h1 className="text-7xl text-center md:text-8xl font-bold animate-fade-up animate-once animate-duration-[1000ms]">
            Seotic for <span className="text-yellow-400">startup</span>
          </h1>
          <p className="mt-2 mx-2 md:mx-0 text-md md:text-xl text-center animate-fade-down animate-once animate-duration-[3000ms]">
           Startups get up to 6 months free with over $3,000 in savings with our partners!
          </p>
          <div className="flex flex-col items-center justify-center mt-20">
       
            <a href="https://app.seotic.co/register" title="create account" className="flex items-center uppercase px-10 py-3 bg-yellow-300 text-yellow-900 rounded-lg hover:bg-yellow-400 text-medium rounded hover:bg-yellow-300 font-medium ">
              Apply Now           </a>
            
       
          </div>
        </div>
     
      </div>
      
    </section>
        
    </>
  );
};

export default Hero;
